export const IconName = {
	ADD: 'add',
	ALERT: 'exclamation',
	BACK: 'arrow-small-left',
	DELETE: 'trash',
	CROWN: 'crown',
	READ: 'envelope-open',
	UNREAD: 'envelope',
	UNDO: 'rotate-right',
	SAVE: 'file-download',
	EDIT: 'file-edit',
	PROFILE: 'user',
	PLUS: 'plus',
	CROSS: 'cross',
	CHECK_CIRCLE: 'check-circle',
	CHECK: 'check',
	DOUBLE_CHECK: 'double-check',
	HISTORY: 'rectangle-vertical-history',
	DOWNLOAD: 'file-download',
	UPLOAD: 'file-upload',
	ALARM: 'light-emergency-on',
	BELL: 'bell',
	ARROW_RIGHT: 'arrow-right',
	ARROW_LEFT: 'arrow-left',
	ARROW_SMALL_RIGHT: 'arrow-small-right',
	ARROW_SMALL_LEFT: 'arrow-small-left',
	ARROW_SMALL_UP: 'arrow-small-up',
	ARROW_SMALL_DOWN: 'arrow-small-down',
	ANGLE_SMALL_RIGHT: 'angle-small-right',
	ANGLE_SMALL_LEFT: 'angle-small-left',
	ANGLE_SMALL_DOWN: 'angle-small-down',
	ANGLE_SMALL_UP: 'angle-small-up',
	PLUS_SMALL: 'plus-small',
	CROSS_SMALL: 'cross-small',
	DOCUMENT: 'document',
	COMPLIANCE_DOCUMENT: 'compliance-document',
	ADD_DOCUMENT: 'add-document',
	DELETE_DOCUMENT: 'delete-document',
	FILE: 'file',
	FILE_EDIT: 'file-edit',
	FILE_USER: 'file-user',
	FILE_UPLOAD: 'file-upload',
	FILE_DOWNLOAD: 'file-download',
	ENVELOPE: 'envelope',
	ENVELOPE_OPEN: 'envelope-open',
	ENVELOPE_PLUS: 'envelope-plus',
	CHART_HISTOGRAM: 'chart-histogram',
	HOURGLASS_END: 'hourglass-end',
	TIME_PAST: 'time-past',
	SHIELD_CHECK: 'shield-check',
	EXCLAMATION: 'exclamation',
	COPY: 'copy',
	REFRESH: 'refresh',
	QRCODE: 'qrcode',
	BOOKMARK: 'bookmark',
	STAR: 'star',
	USER_EDIT: 'user-edit',
	PENCIL: 'pencil',
	BUILDING: 'building',
	CASE: 'case',
	EYE: 'eye',
	EYE_CROSSED: 'eye-crossed',
	MENU_DOTS: 'menu-dots',
	MENU_DOTS_VERTICAL: 'menu-dots-vertical',
	GRIP_VERTICAL: 'grip-vertical',
	SEARCH: 'search',
	SEARCH_DOCUMENT: 'search-document',
	SEARCH_PERSON: 'search-person',
	SEARCH_STOP: 'search-stop',
	ZOOM_IN: 'zoom-in',
	ZOOM_OUT: 'zoom-out',
	TRASH: 'trash',
	TRASH_DELETE: 'trash-delete',
	FLASK: 'flask',
	BRIEFCASE: 'briefcase',
	MEMBER_LIST: 'member-list',
	DELETE_USER: 'delete-user',
	USER_ADD: 'user-add',
	USER_PEN: 'user-pen',
	ARROW_UP_RIGHT_FROM_SQUARE: 'arrow-up-right-from-square',
	MINUS: 'minus',
	MINUS_SMALL: 'minus-small',
	MINUS_CIRCLE: 'minus-circle',
	INFO_CIRCLE: 'info-circle',
	LINK: 'link',
	UNLINK: 'unlink',
	DRAWER_EMPTY: 'drawer-empty',
	CAMERA: 'camera',
	VIDEO_CAMERA_ALT: 'video-camera-alt',
	MODE_PORTRAIT: 'mode-portrait',
	USERS: 'users',
	API: 'api',
	BANK: 'bank',
	BOOK_USER: 'book-user',
	BOOKS: 'books',
	BULLSEYE_POINTER: 'bullseye-pointer',
	CALCULATOR_BILL: 'calculator-bill',
	CALENDAR: 'calendar',
	CORPORATE_ALT: 'corporate-alt',
	DATA_REPORT: 'data-report',
	DEPARTMENT_STRUCTURE: 'department-structure',
	ENVELOPE_DOT: 'envelope-dot',
	FORM: 'form',
	HOOK: 'hook',
	ID_BADGE: 'id-badge',
	ID_CARD: 'id-card',
	ID_CARD_CLIP_ALT: 'id-card-clip-alt',
	KEY: 'key',
	LOCK: 'lock',
	MEMBER_SEARCH: 'member-search',
	NEWSPAPER: 'newspaper',
	NOTEBOOK_ALT: 'notebook-alt',
	PAPER_PLANE_LAUNCH: 'paper-plane-launch',
	PORTFOLIO: 'portfolio',
	SELLER: 'seller',
	SETTINGS_SLIDERS: 'settings-sliders',
	SQUARE_CODE: 'square-code',
	TEMPLATE_ALT: 'template-alt',
	USER_HEADSET: 'user-headset',
	USERS_ALT: 'users-alt',
	SIDEBAR: 'sidebar',
	INFO: 'info',
	DASHBOARD: 'dashboard',
	LIST_CHECK: 'list-check',
	BELL_NOTIFICATION: 'bell-notification',
	SEARCH_ALT: 'search-alt',
	FILTER: 'filter',
	FILTER_CLEAR: 'filter-clear',
	COLUMNS: 'columns',
	SUN: 'sun',
	MOON: 'moon',
	SUN_MOON: 'sun-moon',
	HAND_WAVE: 'hand-wave',
	CALENDAR_CLOCK: 'calendar-clock',
	ACCEPT_DOCUMENT: 'accept-document',
	PASSPORT: 'passport',
	CLOUD_UPLOAD: 'cloud-upload',
	CLOUD_UPLOAD_ALT: 'cloud-upload-alt',
	TALLY_2: 'tally-2',
	ARROW_DOTTED_HORIZONTAL: 'arrows-from-dotted-line-horizontal',
	ARROW_DOTTED_VERTICAL: 'arrows-from-dotted-line-vertical',
	SPLIT_LEFT: 'split-left',
	SPLIT_RIGHT: 'split-right',
	SPLIT_TOP: 'split-top',
	SPLIT_BOTTOM: 'split-bottom',
	ASTERISK: 'asterisk',
	SUMMARY_CHECK: 'summary-check',
	LIST_TIMELINE: 'list-timeline',
	APPS_SORT: 'apps-sort',
	CONTAIN_ARROWS: 'contain-arrows',
	EXPAND_ARROWS: 'expand-arrows',
	TRIGGERS: 'triggers',
	WORKFLOW_SETTING: 'workflow-setting',
};

export const Icons = {
	...IconName,
	BACK: IconName.ARROW_SMALL_LEFT,
	FORWARD: IconName.ARROW_SMALL_RIGHT,
	UP: IconName.ARROW_SMALL_UP,
	RIGHT: IconName.ARROW_SMALL_RIGHT,
	LEFT: IconName.ARROW_SMALL_LEFT,
	DOWN: IconName.ARROW_SMALL_DOWN,
	DELETE: IconName.TRASH,
	READ: IconName.ENVELOPE_OPEN,
	UNREAD: IconName.ENVELOPE,
	CHEVRON_DOWN: IconName.ANGLE_SMALL_DOWN,
	CHEVRON_LEFT: IconName.ANGLE_SMALL_LEFT,
	CHEVRON_RIGHT: IconName.ANGLE_SMALL_RIGHT,
	CHEVRON_UP: IconName.ANGLE_SMALL_UP,
	RELOAD: IconName.REFRESH,
	VISIBLE: IconName.EYE,
	HIDDEN: IconName.EYE_CROSSED,
	THREE_DOTS: IconName.MENU_DOTS,
	RESET: IconName.REFRESH,
	VERSIONS: IconName.LIST_TIMELINE,
	UPLOAD: IconName.FILE_UPLOAD,
	DOWNLOAD: IconName.FILE_DOWNLOAD,
	CASE: IconName.BRIEFCASE,
	COMPANY: IconName.BUILDING,
	BUSINESS: IconName.BUILDING,
	USER_ROLE: IconName.MEMBER_LIST,
	USER_DELETE: IconName.DELETE_USER,
	USER_EDIT: IconName.USER_PEN,
	EXTERNAL: IconName.ARROW_UP_RIGHT_FROM_SQUARE,
	EMPTY: IconName.DRAWER_EMPTY,
	REMOVE: IconName.MINUS,
	VIDEO: IconName.VIDEO_CAMERA_ALT,
	USER_FRAME: IconName.MODE_PORTRAIT,
	CLEAR: IconName.CROSS_SMALL,
	SPLIT: IconName.ARROW_DOTTED_VERTICAL,
	REQUIRED: IconName.ASTERISK,
	SUMMARY: IconName.SUMMARY_CHECK,
	TIMELINE: IconName.LIST_TIMELINE,
	SORT: IconName.APPS_SORT,
	ADD_M: IconName.ADD,
	WORKFLOW_SETTING: IconName.WORKFLOW_SETTING,
};

export type IconType = (typeof Icons)[keyof typeof Icons];

export type IconNameOrString = IconType | string;
